import { FC } from "react";
import styles from "./CommonBanner.module.css";
import clsx from "clsx";

const CommonBanner: FC = ({ children }) => {
  return (
    <div className={styles.root}>
      <div className={clsx("container", styles.content)}>
        <h1>{children}</h1>
      </div>
    </div>
  );
};

export default CommonBanner;
